/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Interact_ListenInputs */

const en_onboarding_interact_listen = /** @type {(inputs: Onboarding_Interact_ListenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to audiobooks & podcasts`)
};

const es_onboarding_interact_listen = /** @type {(inputs: Onboarding_Interact_ListenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucho audiolibros y podcasts`)
};

/**
* | output |
* | --- |
* | "Listen to audiobooks & podcasts" |
*
* @param {Onboarding_Interact_ListenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_interact_listen = /** @type {((inputs?: Onboarding_Interact_ListenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Interact_ListenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_interact_listen(inputs)
	return en_onboarding_interact_listen(inputs)
});